import { Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles as styles } from '../style/gstheme';

class AccessHeader extends React.Component {

    render() {

        const { classes, title } = this.props;

        return (
            <div>
                <div style={{ margin: 'auto', borderRadius: 64, padding: '24px', width: '64px', height: '64px', backgroundColor: 'rgb(238, 238, 238)' }}>
                    <img style={{ width: 60 }} src="/images/large-login.png" alt="Login logo" />
                </div>
                <Typography className={classes.accessHeading} variant="h4">{title}</Typography>
            </div>
        );
    }
}

AccessHeader.propTypes = {
    title: PropTypes.string.isRequired,
    classes: PropTypes.object
};

export default withStyles(styles)(AccessHeader);